import React from "react";
import { TouchableBox, Box } from "./AHTheme/Box";

import { useLayoutContext } from "./LayoutProvider";
import { AHText } from "./Text";

/*

Use this to select categories for a saveable entity.
E.g
Do not use for filtering etc.
*/

function SelectorItemCompact(props: {
  label: string;
  selected: boolean;
  onPress: () => void;
}) {
  const layout = useLayoutContext();

  return (
    <TouchableBox
      onPress={() => {
        props.onPress();
      }}
      hitSlop={{ top: 20, bottom: 10 }}
    >
      <Box
        spaceHorizontal="medium"
        style={{
          height: layout.circle.medium,
          alignItems: "center",
          justifyContent: "center",
        }}
        cornerRadius="full"
        color={props.selected ? "primary" : "surface"}
      >
        <AHText
          type="subtitle"
          color={props.selected ? "text-inverted" : "text-washed"}
        >
          {props.label}
        </AHText>
      </Box>
    </TouchableBox>
  );
}

export function CategorySelectorCompact(props: { children: React.ReactNode }) {
  return (
    <Box style={{ flexDirection: "row" }}>
      <Box
        spaceVertical="xsmall"
        cornerRadius="full"
        spaceHorizontal="xsmall"
        borderColor="border-primary"
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          borderWidth: 1,
        }}
      >
        {props.children}
      </Box>
    </Box>
  );
}

CategorySelectorCompact.Item = SelectorItemCompact;
